import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FiBookOpen } from 'react-icons/fi';
import { Colors } from '../utils/colors';
import { Sizes } from '../utils/sizes';

const ebooks = [
  { id: 'cifras-advento',         title: 'Advento',           image: '/capaEbooksLoja/musicasAdvento.png',      price: 1790 },
  { id: 'cifras-natal',           title: 'Natal',             image: '/capaEbooksLoja/musicasnatal.png',        price: 1790 },
  { id: 'cifras-quaresma',        title: 'Quaresma',          image: '/capaEbooksLoja/musicasquaresma.png',     price: 1790 },
  { id: 'cifras-pascoal',         title: 'Páscoa',            image: '/capaEbooksLoja/musicaspascoa.png',       price: 1790 },
  { id: 'cifras-tempo-comum',     title: 'Tempo Comum',       image: '/capaEbooksLoja/tempocomum.png',          price: 1790 },
  { id: 'cifras-partes-fixas',    title: 'Partes Fixas',      image: '/capaEbooksLoja/musicaspartesfixas.png',  price: 1790 },
  { id: 'cifras-marianas',        title: 'Marianas',          image: '/capaEbooksLoja/marianas.png',            price: 1790 },
  { id: 'cifras-adoracao',        title: 'Adoração',          image: '/capaEbooksLoja/adoracao.png',            price: 1790 },
  { id: 'cifras-grupos-oracao',   title: 'Grupos de Oração',  image: '/capaEbooksLoja/gruposdeoracao.png',      price: 1790 },
  { id: 'cifras-mais-conhecidas', title: 'Mais Conhecidas',   image: '/capaEbooksLoja/maisconhecidas.png',      price: 1790 },
  { id: 'cifras-que-nos-marcaram',title: 'Que Nos Marcaram',  image: '/capaEbooksLoja/musicasmarcantes.png',    price: 1790 },
  { id: 'cifras-infantis',        title: 'Infantis',          image: '/capaEbooksLoja/musicasinfantis.png',     price: 1790 },
];

const Wrap = styled.section`
  width: 100%;
  background: #0f0f0f;
  padding: 80px 24px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.2), transparent);
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const Label = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 10px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.4rem, 2.5vw, 2rem);
  font-weight: 800;
  margin: 0;

  span { color: ${Colors.yellow}; }
`;

const Grid = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
`;

const BookCard = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 120px;
  transition: transform 0.15s;

  @media (max-width: ${Sizes.mediaQueryBreak3}) {
    width: 100px;
  }

  &:hover {
    transform: translateY(-4px);
  }

  &:hover .cover {
    border-color: rgba(255,215,0,0.5);
    box-shadow: 0 8px 24px rgba(0,0,0,0.5);
  }
`;

const Cover = styled.div`
  width: 120px;
  height: 160px;
  background-image: url('${p => p.img}');
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.07);
  box-shadow: 0 4px 16px rgba(0,0,0,0.4);
  transition: border-color 0.15s, box-shadow 0.15s;

  @media (max-width: ${Sizes.mediaQueryBreak3}) {
    width: 100px;
    height: 134px;
  }
`;

const BookTitle = styled.span`
  color: rgba(255,255,255,0.65);
  font-size: 0.72rem;
  text-align: center;
  line-height: 1.3;
`;

const BookPrice = styled.span`
  color: ${Colors.yellow};
  font-size: 0.75rem;
  font-weight: 700;
`;

const Section = ({ modalShow, setModalShow }) => {
  const navigate = useNavigate();

  return (
    <Wrap>
      <Header>
        <Label><FiBookOpen size={13} /> e-Books individuais</Label>
        <Title>
          Prefere escolher <span>o seu favorito</span>?
        </Title>
      </Header>

      <Grid>
        {ebooks.map((ebook) => (
          <BookCard key={ebook.id} onClick={() => navigate(`/produto/${ebook.id}`)}>
            <Cover className="cover" img={ebook.image} />
            <BookTitle>{ebook.title}</BookTitle>
            <BookPrice>R$ {(ebook.price / 100).toFixed(2).replace('.', ',')}</BookPrice>
          </BookCard>
        ))}
      </Grid>
    </Wrap>
  );
};

export default Section;
